import { HealthRecordsDocumentView } from "../ui-components";
import { useNavigate } from "react-router-dom";

const documentTypeOptions = [
  "ANA (Antinuclear Antibody)",
  "BMP (Basic Metabolic Panel)",
  "CBC (Complete Blood Count)",
  "Glucose Level",
  "HIV Antibody Test",
  "Lyme Antibody (Borrelia Antibody)",
  "Pap Smear",
  "PSA (Prostate Specific Antigen)",
  "MRI (Magnetic Resonance Imaging)",
];

const HealthRecordsDocumentPage = () => {
  const navigate = useNavigate();
  return (
    <HealthRecordsDocumentView
      overrides={{
        DocumentViewCard: {
          overrides: {
            dvcDocumentTypeSelect: {
              options: documentTypeOptions,
              placeholder: "Select",
              value:'MRI (Magnetic Resonance Imaging)',
            },
            dvcDocumentDateTextField: {
                value: '03/21/2023'
            },
            dvcDocumentDescriptionTextArea: {
                value: 'This is an MRI imaging set that was taken when symptoms started to get worst'
            },
            dvcPreviewButton:{
                onClick: () => navigate("/user/hr/documents/:type/preview/"),
            }
          },
        },
      }}
    />
  );
};

export default HealthRecordsDocumentPage;
